import { css } from '@emotion/css';
import { ColorsPrimary500, ColorsPrimary700 } from '@efexteam/design-tokens';

const copyButton = css({
  color: ColorsPrimary500,
  '&:hover': {
    color: ColorsPrimary700,
  },
});

const CopyButtonStyles = {
  copyButton,
};

export default CopyButtonStyles;
